// 弹窗方式登录
export const googleLogin = () => {
  if (window.firebase && window.firebase.auth) {
    const provider = new firebase.auth.GoogleAuthProvider()
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
          return firebase
            .auth()
            .signInWithPopup(provider)
            .then((result) => {
              resolve(result)
            })
            .catch((error) => {
              reject(error)
              // const errorMsg = 'GoogleLoginError: ' + JSON.stringify(error)
              // window.$apm &&
              //   $apm.captureError &&
              //   $apm.captureError(new Error(errorMsg))
            })
        })
        .catch((error) => {
          reject(error)
          // window.console.log('google sign in error ===>>>', error)
          // const errorMsg = 'GoogleLoginError: ' + JSON.stringify(error)
          // window.$apm &&
          //   $apm.captureError &&
          //   $apm.captureError(new Error(errorMsg))
        })
    })
  }
}

// 重定向方式登录
export function googleLoginRedirect() {
  if (!process.client) {
    return
  }
  if (window.firebase && window.firebase.auth) {
    const provider = new firebase.auth.GoogleAuthProvider()
    firebase.auth().signInWithRedirect(provider)
  }
}

// 获取google重定向方法登录后的用户信息
export function getGoogleLoginUserInfo() {
  if (window.firebase && window.firebase.auth) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .getRedirectResult()
        .then((result) => {
          if (result) {
            const { user } = result
            if (user) {
              resolve(result)
            } else {
              reject()
            }
          } else {
            reject()
          }
        })
    })
  }
}
